import { canScheduleTransactions } from "@common/helpers/domains/accounting/scheduleTransactionFit";
import { ScheduleTemplateListItem } from "@common/schemas/domains/accounting/scheduleTemplate.schema";
import {
    ScheduleTemplateStatus,
    ScheduleType,
} from "@common/types/domains/accounting/schedule";
import {
    FormRuleActionType,
    TransactionRuleActionFormSchema,
} from "../constants";

export function getRequiredScheduleEntityIds({
    conditionEntityIds,
    actions,
}: {
    conditionEntityIds: number[];
    actions: TransactionRuleActionFormSchema[];
}): number[] {
    const entityActionIds = actions.flatMap((action) =>
        action.actionType === FormRuleActionType.ENTITY &&
        action.value?.entityId != null
            ? [action.value.entityId]
            : [],
    );
    return [...new Set([...conditionEntityIds, ...entityActionIds])];
}

export function getEligibleScheduleTemplates({
    templates,
    requiredEntityIds,
    isExpensesEnabled,
}: {
    templates: ScheduleTemplateListItem[];
    requiredEntityIds: number[];
    isExpensesEnabled: boolean;
}): ScheduleTemplateListItem[] {
    return templates.filter(
        (template) =>
            template.status === ScheduleTemplateStatus.active &&
            (isExpensesEnabled || template.type !== ScheduleType.expense) &&
            canScheduleTransactions(template) &&
            !template.hasSpecificDateAnchor &&
            requiredEntityIds.every((entityId) =>
                template.entityIds.includes(entityId),
            ),
    );
}
